export default __webpack_public_path__ + "static/media/invalid-name@3x.4d6ddb91.webp";